const Logo = () => {
  return <h2 className="text-lg">Hirelo</h2>;
};

export default Logo;
